import GenerateSpreadsheetButton from './generate-spreadsheet-button';

export default GenerateSpreadsheetButton;
